import { ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Cascader, Checkbox, Col, Form, Input, List, Modal, Row, Select, Space, Tooltip, Upload } from "antd";
import { getMediaUrl } from "config/env";
import Axios from "middleware/axiosInstance";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import TextArea from "antd/es/input/TextArea";
import { getBase64, getBranchListFromResponse } from "functions/functions";
import Loading from "layouts/Loading/Loading";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
const { Option } = Select;

const flattenCategoriesTree = (categories = []) => {
  const result = [];
  const traverse = (nodes) => {
    (nodes || []).forEach((node) => {
      result.push(node);
      const children = node.children || node.children_recursive || [];
      if (children.length > 0) {
        traverse(children);
      }
    });
  };
  traverse(categories);
  return result;
};

const normalizeBadges = (value) => {
  if (value === undefined || value === null || value === '') {
    return [];
  }

  return Array.isArray(value) ? value.slice(0, 1) : [value];
};

const AddAndEditFood = () => {
  // start react router url params
  const UrlParams = useParams();
  const { foodId } = UrlParams
  const isInEditMode = foodId ? true : false
  // end react router url params
  const navigate = useNavigate()
  const location = useLocation();
  const currentBranch = new URLSearchParams(location.search).get("branch") || "";

  const [form] = Form.useForm();

  const [foodCategories, setFoodCategories] = useState([]);
  const [rootCategories, setRootCategories] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [content, setContent] = useState(null);
  const [badges, setBadges] = useState([]); // list of badge objects
  const [foodInfoForEdit, setFoodInfoForEdit] = useState(null)
  const [selectedCategoryPath, setSelectedCategoryPath] = useState([]);
  const [isDrink, setIsDrink] = useState(false)
  const [isEspresso, setIsEspresso] = useState(false)
  const [hasTwoSizes, setHasTwoSizes] = useState(false)
  const [selectedContents, setSelectedContents] = useState([]) // Array of {id, name, order}




  // upload image 

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [fileList, setFileList] = useState([]);
  const [imageOfFood, setImageOfFood] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const sliderSlotMapRef = useRef({});
  const sliderInitialSlotsRef = useRef(new Set());
  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  const syncSliderFileList = (incomingFileList) => {
    const nextSlotMap = { ...sliderSlotMapRef.current };
    const nextUids = new Set(incomingFileList.map((file) => file.uid));

    Object.keys(nextSlotMap).forEach((uid) => {
      if (!nextUids.has(uid)) {
        delete nextSlotMap[uid];
      }
    });

    const usedSlots = new Set(Object.values(nextSlotMap));
    const availableSlots = [];
    for (let index = 0; index < 4; index++) {
      if (!usedSlots.has(index)) {
        availableSlots.push(index);
      }
    }

    const normalizedFileList = incomingFileList.map((file) => {
      let slotIndex = nextSlotMap[file.uid];

      if (typeof slotIndex !== "number") {
        slotIndex = availableSlots.shift();
        nextSlotMap[file.uid] = slotIndex;
      }

      return {
        ...file,
        slotIndex,
      };
    });

    sliderSlotMapRef.current = nextSlotMap;
    setFileList(normalizedFileList);
  };

  const handleChange = ({ fileList: newFileList }) => syncSliderFileList(newFileList);
  const ImageOfFoodChange = ({ fileList: newFileList }) => setImageOfFood(newFileList);
  const applySliderImagesToFood = async (food, preserveRemovedSlots = false) => {
    for (let index = 0; index < 4; index++) {
      const file = fileList.find((item) => item.slotIndex === index);

      if (!file) {
        if (preserveRemovedSlots && sliderInitialSlotsRef.current.has(index)) {
          food[`imag_${index + 1}`] = null;
        } else {
          delete food[`imag_${index + 1}`];
        }
        continue;
      }

      if (file.originFileObj) {
        food[`imag_${index + 1}`] = await getBase64(file.originFileObj)
      } else {
        delete food[`imag_${index + 1}`]
      }
    }
  };
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  // end of upload image


  const getFoodCategories = () => {
    Axios.get("/category").then((res) => {
      const categoriesRoot = Array.isArray(res.data)
        ? res.data
        : res.data?.categories || [];
      setRootCategories(categoriesRoot);
      setFoodCategories(flattenCategoriesTree(categoriesRoot));
    }).catch(err => console.log(err))
  }

  const getBranches = () => {
    Axios.get("/branches").then((res) => {
      const branches = getBranchListFromResponse(res.data);
      setBranchOptions(branches);
    }).catch(err => {
      console.log(err);
      setBranchOptions([]);
    });
  }

  const categoryPathById = useMemo(() => {
    if (!foodCategories.length) return {};

    const byId = foodCategories.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});

    const paths = {};
    foodCategories.forEach((item) => {
      const path = [];
      let current = item;
      let safetyCounter = 0;

      while (current && safetyCounter < 20) {
        path.unshift(current.id);
        if (current.parent_id === null || current.parent_id === undefined) break;
        current = byId[current.parent_id];
        safetyCounter += 1;
      }

      paths[item.id] = path;
    });

    return paths;
  }, [foodCategories]);

  const categoryTreeOptions = useMemo(() => {
    const mapToOption = (category) => ({
      value: category.id,
      label: category.title_fa,
      children: (category.children_recursive || category.children || []).map(mapToOption)
    });
    return (rootCategories || []).map(mapToOption);
  }, [rootCategories]);

  const getBadges = () => {
    Axios.get("/badge").then((res) => {
      setBadges(res.data || []);
    }).catch(err => {
      console.log(err);
      setBadges([]);
    })
  }

  const getContent = () => {
    Axios.get("/content").then((res) => {
      setContent(res.data)
    }).catch(err => console.log(err))
  }

  const resetDrinkLikeDependentFields = () => {
    form.setFieldsValue({
      final_price_family: null,
      price_family: null,
      final_price_two: null,
      price_two: null,
      content_id: []
    })
    setSelectedContents([])
  }

  const handleDrinkLikeChange = (fieldName, checked) => {
    const nextIsDrink = fieldName === "is_drink"
      ? checked
      : (checked ? false : isDrink)
    const nextIsEspresso = fieldName === "is_espresso"
      ? checked
      : (checked ? false : isEspresso)
    const wasDrinkLike = isDrink || isEspresso
    const nextDrinkLike = nextIsDrink || nextIsEspresso

    setIsDrink(nextIsDrink)
    setIsEspresso(nextIsEspresso)
    if (!nextIsDrink) {
      setHasTwoSizes(false)
    }
    form.setFieldsValue(
      fieldName === "is_drink"
        ? {
          is_drink: checked,
          is_espresso: checked ? false : isEspresso,
          ...(!checked ? { has_two_sizes: false } : {}),
        }
        : {
          is_espresso: checked,
          is_drink: checked ? false : isDrink,
          ...(checked ? { has_two_sizes: false } : {}),
        }
    )

    if (!wasDrinkLike && nextDrinkLike) {
      resetDrinkLikeDependentFields()
    }
  }

  const SubmitNewFood = async (food) => {
    try {
      setSubmitLoading(true);
      food.is_drink = Boolean(food.is_drink);
      food.is_espresso = Boolean(food.is_espresso);
      food.has_two_sizes = food.is_drink ? Boolean(food.has_two_sizes) : false;
      if (food.is_drink) {
        food.is_espresso = false;
        if (!food.has_two_sizes) {
          food.price_two = null;
          food.final_price_two = null;
          food.price_family = null;
          food.final_price_family = null;
        }
      }
      if (food.is_espresso) {
        food.is_drink = false;
      }
      const categoryPath = food.category_path || [];
      food.category_id = categoryPath[categoryPath.length - 1];
      delete food.category_path;
      food.branches = Array.isArray(food.branches) ? food.branches : [];

      if (imageOfFood[0]) {
        food.original_image = await getBase64(imageOfFood[0].originFileObj)
      }

      await applySliderImagesToFood(food);

      // Format content_id with order
      if (selectedContents.length > 0) {
        food.content_id = selectedContents.map((item, index) => ({
          id: item.id,
          order: index
        }))
      }

      food.badges = normalizeBadges(food.badges);

      Axios.post("/food", food)
        .then(res => {
          navigate({ pathname: "/foods", search: location.search });
          OpenNotificationWithIcon("ثبت موفق", "با موفقیت افزوده شد");
        })
        .catch(err => {
          OpenNotificationWithIcon("ثبت ناموفق", "ثبت انجام نشد", "danger")
        })
        .finally(() => {
          setSubmitLoading(false);
        })
    }
    catch {
      OpenNotificationWithIcon("ثبت ناموفق", "ثبت انجام نشد", "danger")
      setSubmitLoading(false);
    }
  }


  const submitEditFood = async (food) => {
    // console.log(food)
    setSubmitLoading(true);
    food.is_drink = Boolean(food.is_drink);
    food.is_espresso = Boolean(food.is_espresso);
    food.has_two_sizes = food.is_drink ? Boolean(food.has_two_sizes) : false;
    if (food.is_drink) {
      food.is_espresso = false;
      if (!food.has_two_sizes) {
        food.price_two = null;
        food.final_price_two = null;
        food.price_family = null;
        food.final_price_family = null;
      }
    }
    if (food.is_espresso) {
      food.is_drink = false;
    }
    const categoryPath = food.category_path || selectedCategoryPath || [];
    food.category_id = categoryPath[categoryPath.length - 1];
    delete food.category_path;
    food.branches = Array.isArray(food.branches) ? food.branches : [];

    if (imageOfFood[0]) {
      if (imageOfFood[0].originFileObj) {
        food.original_image = await getBase64(imageOfFood[0].originFileObj)
      }
      else {
        delete food.original_image
      }
    }
    else {
      food.original_image = null
    }


    await applySliderImagesToFood(food, true);

    // Format content_id with order
    if (selectedContents.length > 0) {
      food.content_id = selectedContents.map((item, index) => ({
        id: item.id,
        order: index
      }))
    } else {
      food.content_id = []
    }

    food.badges = normalizeBadges(food.badges);

    Axios.put(`/food/${foodId}`, food)
      .then(res => {
        navigate({ pathname: "/foods", search: location.search })
        OpenNotificationWithIcon("ویرایش موفق", "با موفقیت ویرایش شد")
      })
      .catch(err => {
        OpenNotificationWithIcon("ویرایش ناموفق", "ویرایش انجام نشد", "error")

      })
      .finally(() => {
        setSubmitLoading(false);
      })
  }


  useEffect(() => {
    if (isInEditMode) {
      getFoodInfoForEdit()
    }
    getFoodCategories()
    getBranches()
    getContent()
    getBadges()
  }, []);

  // Sync form value with selectedContents
  useEffect(() => {
    if (selectedContents.length > 0) {
      form.setFieldsValue({
        content_id: selectedContents.map(item => item.id)
      })
    } else {
      form.setFieldsValue({
        content_id: []
      })
    }
  }, [selectedContents, form]);

  useEffect(() => {
    if (!isInEditMode || !foodInfoForEdit?.category_id) return;
    const fullPath = categoryPathById[foodInfoForEdit.category_id];
    if (!fullPath?.length) return;

    setSelectedCategoryPath(fullPath);
    form.setFieldsValue({
      category_path: fullPath
    });
  }, [isInEditMode, foodInfoForEdit, categoryPathById, form]);

  useEffect(() => {
    if (!foodInfoForEdit) return;
    const selectedBranches = Array.isArray(foodInfoForEdit.branches)
      ? foodInfoForEdit.branches
      : foodInfoForEdit.branch_options?.filter((branch) => branch.selected).map((branch) => branch.id) || [];

    form.setFieldsValue({
      branches: selectedBranches,
    });
  }, [foodInfoForEdit, form]);

  useEffect(() => {
    if (isInEditMode || !currentBranch) return;

    form.setFieldsValue({
      branches: [currentBranch],
    });
  }, [currentBranch, form, isInEditMode]);



  const isDrinkOnchangeHandler = () => {
    handleDrinkLikeChange("is_drink", !isDrink)
  }

  const isEspressoOnchangeHandler = () => {
    handleDrinkLikeChange("is_espresso", !isEspresso)
  }

  const hasTwoSizesOnchangeHandler = (e) => {
    const checked = e.target.checked;
    setHasTwoSizes(checked);
    if (!checked) {
      form.setFieldsValue({
        price_two: null,
        final_price_two: null,
        price_family: null,
        final_price_family: null,
      });
    }
  };

  // Handle adding content to selected list
  const handleAddContent = (contentId) => {
    const contentItem = content?.find(c => c.id === contentId)
    if (contentItem && !selectedContents.find(sc => sc.id === contentId)) {
      const newContent = {
        id: contentId,
        name: contentItem.contents_fa,
        order: selectedContents.length
      }
      setSelectedContents([...selectedContents, newContent])
      form.setFieldsValue({ content_select: undefined }) // Clear the select
    }
  }

  // Handle removing content from selected list
  const handleRemoveContent = (contentId) => {
    const newContents = selectedContents.filter(sc => sc.id !== contentId)
      .map((item, index) => ({ ...item, order: index }))
    setSelectedContents(newContents)
  }

  // Handle moving content up
  const handleMoveUp = (index) => {
    if (index > 0) {
      const newContents = [...selectedContents]
      const temp = newContents[index]
      newContents[index] = newContents[index - 1]
      newContents[index - 1] = temp
      // Update orders
      newContents.forEach((item, i) => {
        item.order = i
      })
      setSelectedContents(newContents)
    }
  }

  // Handle moving content down
  const handleMoveDown = (index) => {
    if (index < selectedContents.length - 1) {
      const newContents = [...selectedContents]
      const temp = newContents[index]
      newContents[index] = newContents[index + 1]
      newContents[index + 1] = temp
      // Update orders
      newContents.forEach((item, i) => {
        item.order = i
      })
      setSelectedContents(newContents)
    }
  }


  const checkHasImageAndAddImagesToFileList = (data) => {
    // set exist original_image of food in editing mode
    if (data.original_image) {
      setImageOfFood([{
        "thumbUrl": getMediaUrl(data.original_image)
        , "preview": getMediaUrl(data.original_image)

      }])
    }
    const temp = []
    // set esist images of food imag_1 ... imag_4
    for (let index = 1; index < 5; index++) {
      if (data[`imag_${index}`]) {
        temp.push({
          "slotIndex": index - 1,
          "uid": `existing-slider-image-${index}`,
          "name": `imag_${index}`,
          "thumbUrl": getMediaUrl(data[`imag_${index}`]),
          "preview": getMediaUrl(data[`imag_${index}`]),
        })
      }
    }
    sliderInitialSlotsRef.current = new Set(temp.map((file) => file.slotIndex));
    sliderSlotMapRef.current = temp.reduce((acc, file) => {
      acc[file.uid] = file.slotIndex;
      return acc;
    }, {});
    setFileList(temp.sort((a, b) => a.slotIndex - b.slotIndex))
  }


  const getFoodInfoForEdit = () => {
    Axios.get(`/food/${foodId}`).then(res => {
      if (res.data) {
        checkHasImageAndAddImagesToFileList(res.data)
      }
      if (Array.isArray(res.data?.branch_options) && res.data.branch_options.length > 0) {
        setBranchOptions(res.data.branch_options);
      }
      const categoryPath = categoryPathById[res.data.category_id] || [res.data.category_id];
      setSelectedCategoryPath(categoryPath);
      const IsDrink = res.data.is_drink === true || res.data.is_drink === 1
      const IsEspresso = res.data.is_espresso === true || res.data.is_espresso === 1
      const HasTwoSizes = Boolean(res.data.has_two_sizes)
      res.data.is_drink = IsDrink;
      res.data.is_espresso = IsEspresso;
      setIsDrink(IsDrink)
      setIsEspresso(IsEspresso)
      setHasTwoSizes(IsDrink && HasTwoSizes)
      if (res.data.content && res.data.content.length > 0) {
        const response = res.data
        // Content comes sorted by order from API, with pivot.order
        const contentsWithOrder = response.content.map((contentItem, index) => ({
          id: contentItem.id,
          name: contentItem.contents_fa,
          order: contentItem.pivot?.order !== undefined ? contentItem.pivot.order : index
        }))
        // Sort by order to ensure correct sequence
        contentsWithOrder.sort((a, b) => a.order - b.order)
        setSelectedContents(contentsWithOrder)

        // Keep backward compatibility for form
        const temp = []
        response.content.forEach(content => {
          temp.push(content.id)
        });
        response.content_id = temp

        // Prepare badges field for form initial value (single badge)
        if (response.badges && response.badges.length > 0) {
          form.setFieldsValue({ badges: response.badges[0].id })
        } else {
          form.setFieldsValue({ badges: undefined })
        }

        response.has_two_sizes = IsDrink && HasTwoSizes;
        response.category_path = categoryPath;
        setFoodInfoForEdit(response)
      } else {
        res.data.has_two_sizes = IsDrink && HasTwoSizes;
        res.data.category_path = categoryPath;
        setFoodInfoForEdit(res.data)
        setSelectedContents([])
        form.setFieldsValue({ badges: undefined })
      }
    })
      .catch(err => console.log(err))
  }




  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">
          {isInEditMode ? "ویرایش غذا" : "افزودن غذا"}
        </h5>
        {
          isInEditMode && foodInfoForEdit === null ? <Loading /> :


            <Form
              layout="vertical"

              initialValues={foodInfoForEdit}

              form={form}
              autoComplete="off"
              scrollToFirstError
              labelCol={{ xs: 24 }}
              onFinish={isInEditMode ? submitEditFood : SubmitNewFood}

            >
              <Row gutter={8}>
                <Col xs={24} >
                  <Form.Item valuePropName="checked" name="is_drink"
                  >
                    {/* <Tooltip placement="topLeft" title="در صورتی که محصول نوشیدنی است جهت بهبود عملکرد نرم افزار و عدم نیاز به وارد کردن فیلد محتویات غذا این گزینه را انتخاب فرمایید "> */}
                    <Checkbox
                      onChange={() => isDrinkOnchangeHandler()}
                    > محصول نوشیدنی است</Checkbox>
                    {/* </Tooltip> */}

                  </Form.Item>
                </Col>
                {isDrink && (
                  <Col xs={24}>
                    <Form.Item valuePropName="checked" name="has_two_sizes">
                      <Checkbox onChange={hasTwoSizesOnchangeHandler}>
                        نوشیدنی دارای چند سایز است
                      </Checkbox>
                    </Form.Item>
                  </Col>
                )}
                <Col xs={24} >
                  <Form.Item valuePropName="checked" name="is_espresso"
                  >
                    <Checkbox
                      onChange={() => isEspressoOnchangeHandler()}
                    > محصول اسپرسو است</Checkbox>
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12} >
                  <Form.Item valuePropName="checked" name="is_not_exist">
                    <Tooltip placement="topLeft" title="جهت عدم نمایش این غذا در منو، این گزینه را انتخاب فرمایید ">
                      <Checkbox>محصول ناموجود است</Checkbox>
                    </Tooltip>
                  </Form.Item>
                </Col> */}
                <Col xs={24}>
                  <Form.Item
                    label="شعبه‌های فعال"
                    name="branches"
                    rules={[
                      {
                        required: true,
                        type: "array",
                        min: 1,
                        message: "انتخاب حداقل یک شعبه الزامی می باشد",
                      },
                    ]}
                  >
                    <Checkbox.Group
                      options={branchOptions.map((branch) => ({
                        label: branch.name || branch.title_fa || branch.id,
                        value: branch.id,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item
                    label="دسته بندی"
                    name="category_path"
                    rules={[
                      {
                        required: true,
                        message: "انتخاب دسته نهایی الزامی می باشد",
                      },
                    ]}
                  >
                    <Cascader
                      options={categoryTreeOptions}
                      onChange={(value) => setSelectedCategoryPath(value || [])}
                      placeholder="دسته نهایی را انتخاب کنید"
                      changeOnSelect={false}
                      showSearch={{
                        filter: (inputValue, path) =>
                          path.some((option) =>
                            option.label
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                          ),
                      }}
                      expandTrigger="click"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} xl={6}>
                  <Tooltip placement="topLeft" title="تنها یک برچسب (تگ) را می توانید انتخاب نمایید تا بر روی کارت غذا نمایش داده شود">
                    <Form.Item label="برچسب روی کارت غذا (حداکثر ۱)" name="badges">
                      <Select
                        allowClear
                        placeholder="انتخاب برچسب"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().includes(input)
                        }
                      >
                        {badges.map(b => (
                          <Option key={b.id} value={b.id}>
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                              {b.image ? <img src={getMediaUrl(b.image)} style={{ width: 24, height: 24, marginInlineEnd: 8 }} alt={b.title_fa} /> : null}
                              <span>{b.title_fa}</span>
                            </span>
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Tooltip>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label="نام فارسی" name="name_fa"
                    rules={[
                      {
                        required: true,
                        message: "نام فارسی الزامی می باشد",
                      },
                    ]}>
                    <Input placeholder="پیتزا" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label="نام انگلیسی" name="name_en"
                    rules={[
                      {
                        required: true,
                        message: "نام انگلیسی الزامی می باشد",
                      },
                    ]}>
                    <Input placeholder="Pizzza" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label="نام عربی" name="name_ar"
                    rules={[
                      {
                        required: true,
                        message: "نام عربی الزامی می باشد",
                      },
                    ]}
                  >
                    <Input placeholder="الپیتزا" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label=
                    {
                      isEspresso ? "قیمت پنجاه روبوستا" :
                        (isDrink ? (hasTwoSizes ? "قیمت کوچک" : "قیمت") :
                          "قیمت کوچک"
                        )
                    }
                    name="price_single">
                    <Input placeholder="120" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label=
                    {
                      isEspresso ? "قیمت تخفیف پنجاه روبوستا" :
                        (isDrink ? (hasTwoSizes ? "قیمت کوچک پس از تخفیف" : "قیمت با تخفیف") :
                          "قیمت کوچک پس از تخفیف"
                        )
                    }

                    name="final_price_single">
                    <Input placeholder="110" />
                  </Form.Item>
                </Col>
                {(!isDrink || (isDrink && hasTwoSizes)) &&
                  <>
                    <Col xs={24} sm={12} md={8} xl={6}>
                      <Form.Item label={isEspresso ? "قیمت صد عربیکا" : "قیمت متوسط"} name="price_two">
                        <Input placeholder="150" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} xl={6}>
                      <Form.Item label={isEspresso ? "قیمت تخفیف صد عربیکا" : "قیمت متوسط پس از تخفیف"} name="final_price_two">
                        <Input placeholder="140" />
                      </Form.Item>
                    </Col>
                  </>
                }
                {(!isEspresso && (!isDrink || hasTwoSizes)) &&
                  <>
                    <Col xs={24} sm={12} md={8} xl={6}>
                      <Form.Item label="قیمت بزرگ" name="price_family">
                        <Input placeholder="195" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} xl={6}>
                      <Form.Item label="قیمت بزرگ پس از تخفیف" name="final_price_family">
                        <Input placeholder="185" />
                      </Form.Item>
                    </Col>
                  </>
                }
                {!(isDrink || isEspresso) &&
                  <>
                    <Col xs={24} sm={12} md={8} xl={6}>
                      <Form.Item label="مدت زمان حاضر شدن به دقیقه" name="waiting_time">
                        <Input placeholder="20" />
                      </Form.Item>
                    </Col>
                  </>
                }
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label="میزان کالری(کیلو)" name="kcal">
                    <Input placeholder="120" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item
                    label={(isDrink || isEspresso) ? "حجم (cc)" : "وزن (گرم)"}
                    name="grams"
                  >
                    <Input placeholder={(isDrink || isEspresso) ? "330" : "650"} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label="میزان پروتیین" name="proteins">
                    <Input placeholder="320" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label="کربوهیدارت" name="carbs">
                    <Input placeholder="150" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label="چربی" name="fat">
                    <Input placeholder="210" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Form.Item label="اسیدهای چرب" name="trans_fatty_acids">
                    <Input placeholder="210" />
                  </Form.Item>
                </Col>

                {!(isDrink || isEspresso) &&
                  <Col xs={24}>
                    <Form.Item
                      name="content_id"
                      label="محتویات غذا"
                    // rules={[{ 
                    //   validator: () => {
                    //     if (selectedContents.length < 3) {
                    //       return Promise.reject('حداقل 3 محتوی الزامی است!')
                    //     }
                    //     return Promise.resolve()
                    //   }
                    // }]}
                    >
                      <Space direction="vertical" style={{ width: '100%' }}>
                        <Select
                          placeholder="افزودن مواد اولیه..."
                          showSearch
                          value={undefined}
                          onChange={handleAddContent}
                          style={{ width: '100%' }}
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {content?.filter(c => !selectedContents.find(sc => sc.id === c.id))
                            .map(contentItem => (
                              <Option key={contentItem.id} value={contentItem.id}>
                                {contentItem.contents_fa}
                              </Option>
                            ))}
                        </Select>
                        {selectedContents.length > 0 && (
                          <List
                            bordered
                            dataSource={selectedContents}
                            renderItem={(item, index) => (
                              <List.Item
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '8px 16px'
                                }}
                              >
                                <span style={{ flex: 1 }}>
                                  {index + 1}. {item.name}
                                </span>
                                <Space>
                                  <Button
                                    type="text"
                                    icon={<ArrowUpOutlined />}
                                    onClick={() => handleMoveUp(index)}
                                    disabled={index === 0}
                                    size="small"
                                  />
                                  <Button
                                    type="text"
                                    icon={<ArrowDownOutlined />}
                                    onClick={() => handleMoveDown(index)}
                                    disabled={index === selectedContents.length - 1}
                                    size="small"
                                  />
                                  <Button
                                    type="text"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => handleRemoveContent(item.id)}
                                    size="small"
                                  />
                                </Space>
                              </List.Item>
                            )}
                          />
                        )}
                      </Space>
                    </Form.Item>
                  </Col>
                }
                <Col xs={24}>
                  <Form.Item label="توضیحات فارسی" name="description_fa">
                    <TextArea rows={3} maxLength={2000} placeholder="قارچ تازه با سس سیر خوشمزه و ترد" />
                  </Form.Item>
                </Col>

                <Col xs={24}>
                  <Form.Item label="توضیحات انگلیسی" name="description_en">
                    <TextArea rows={3} maxLength={2000} placeholder="Fresh mushrooms with delicious garlic sauce, crispy and tasty" />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item label="توضیحات عربی" name="description_ar">
                    <TextArea rows={3} maxLength={2000} placeholder="فطر طازج مع صلصة ثوم لذيذة ومقرمشة" />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="original_image"
                    label="تصویر"
                  >
                    <Upload
                      listType="picture-card"
                      fileList={imageOfFood}
                      onPreview={handlePreview}
                      onChange={ImageOfFoodChange}
                      beforeUpload={() => false}
                      maxCount={1}
                    >
                      <Tooltip placement="topLeft" title="جهت نمایش بهتر تصویر، لطفا تصویر انتخاب شده به صورت مربع باشد">
                        {uploadButton}
                      </Tooltip>
                    </Upload>
                  </Form.Item>

                </Col>
                <Col xs={24}>
                  <Form.Item
                    label="تصاویر اسلایدر"
                  >

                    <Upload
                      listType="picture-card"
                      fileList={fileList}
                      onPreview={handlePreview}
                      onChange={handleChange}
                      beforeUpload={() => false}
                      maxCount={4}
                    >
                      <Tooltip placement="topLeft" title="جهت نمایش بهتر تصویر، لطفا تصویر انتخاب شده به صورت مربع باشد">
                        {fileList.length >= 4 ? null : uploadButton}
                      </Tooltip>
                    </Upload>
                  </Form.Item>
                  <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                    <img
                      alt="example"
                      style={{
                        width: '100%',
                      }}
                      src={previewImage}
                    />
                  </Modal>
                </Col>


                <Col xs={24} >
                  <Button
                    htmlType="submit"
                    type="primary"
                    loading={submitLoading}
                    disabled={submitLoading}
                  >{isInEditMode ? "ذخیره تغییرات" : "افزودن"}</Button>
                  <Button
                    className="me-3"
                    type="default"
                    disabled={submitLoading}
                    onClick={() => navigate({ pathname: "/foods", search: location.search })}
                  >بازگشت</Button>
                </Col>
              </Row>
            </Form>
        }
      </div>
    </div >
  );
}

export default AddAndEditFood;
